const languagePathMap = {
    en: '/en-gb',
    fr: '/fr',
    nl: '',
};

export const resolveLangSegment = (lng) => {
    const base = lng?.split('-')[0];

    return languagePathMap[base] || languagePathMap[base] === ''
        ? languagePathMap[base]
        : languagePathMap.en;
};

export const getContactUrl = (lng) => {
    return `https://www.care4growing.be${resolveLangSegment(lng)}/contact`;
};